<script lang="ts">
  import { AssetPaths } from '../../assets/asset-store';
  import { FRAME_SLICE } from '../../game/constants/hud';

  const { name = 'menu' }: { name?: string } = $props();

  const { border, edge, fill, ornament } = FRAME_SLICE;
</script>

<!-- Decorative, so aria-hidden and click-through: the content sits above it. -->
<div class="frame" aria-hidden="true">
  <i
    class="frame__fill"
    style:background-image="url({AssetPaths.frame(name, 'C')})"
    style:top="{fill.top}px"
    style:right="{fill.right}px"
    style:bottom="{fill.bottom}px"
    style:left="{fill.left}px"
  ></i>
  <i
    style:background-image="url({AssetPaths.frame(name, 'T')})"
    style:top="0"
    style:left="{edge.left}px"
    style:right="{edge.right}px"
    style:height="{border.top}px"
  ></i>
  <i
    style:background-image="url({AssetPaths.frame(name, 'B')})"
    style:bottom="0"
    style:left="{edge.left}px"
    style:right="{edge.right}px"
    style:height="{border.bottom}px"
  ></i>
  <i
    style:background-image="url({AssetPaths.frame(name, 'L')})"
    style:top="{edge.top}px"
    style:bottom="{edge.bottom}px"
    style:left="0"
    style:width="{border.left}px"
  ></i>
  <i
    style:background-image="url({AssetPaths.frame(name, 'R')})"
    style:top="{edge.top}px"
    style:bottom="{edge.bottom}px"
    style:right="0"
    style:width="{border.right}px"
  ></i>
  <i
    style:background-image="url({AssetPaths.frame(name, 'TL')})"
    style:top="0"
    style:left="0"
    style:width="{ornament.topWidth}px"
    style:height="{ornament.topHeight}px"
  ></i>
  <i
    style:background-image="url({AssetPaths.frame(name, 'TR')})"
    style:top="0"
    style:right="0"
    style:width="{ornament.topWidth}px"
    style:height="{ornament.topHeight}px"
  ></i>
  <i
    style:background-image="url({AssetPaths.frame(name, 'BL')})"
    style:bottom="0"
    style:left="0"
    style:width="{ornament.bottomWidth}px"
    style:height="{ornament.bottomHeight}px"
  ></i>
  <i
    style:background-image="url({AssetPaths.frame(name, 'BR')})"
    style:bottom="0"
    style:right="0"
    style:width="{ornament.bottomWidth}px"
    style:height="{ornament.bottomHeight}px"
  ></i>
</div>

<style>
  .frame {
    position: absolute;
    inset: 0;
    pointer-events: none;
  }

  .frame i {
    position: absolute;
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }

  /* Tiled, not stretched: stretching is how the old frame became a flat wash of one colour. */
  .frame__fill {
    background-repeat: repeat;
    background-size: auto;
  }
</style>
